import React from 'react';
import { volumes, PRICE, FULL_PRICE } from '../data/content';
import { SectionLabel } from './ui/SectionLabel';
import { CtaButton } from './ui/CtaButton';
import { Reveal } from './ui/Reveal';
export function Volumes() {
  return <section id="collection" className="bg-cream px-4 py-14 sm:px-5 sm:py-24" data-id="element-261" data-mp="1856oqobu25m5">
      <div className="mx-auto max-w-6xl" data-id="element-262" data-mp="1c4p3f2d29kgj">
        <Reveal data-id="element-263" data-mp="1c3e35citquu6">
          <SectionLabel data-id="element-264" data-mp="1zv1m989uh1lw">Ogni volume ha un compito</SectionLabel>
          <h2 className="display mx-auto mt-5 max-w-[24ch] text-center text-[1.7rem] text-ink sm:text-[3.1rem]" data-id="element-265" data-mp="1zvkt9txyi5l5">
            6 volumi che li portano{' '}
            <span className="text-orange" data-id="element-266" data-mp="1quwegx0qo177">dal costruire all’inventare.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-center text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-5 sm:text-lg" data-id="element-267" data-mp="1vt7qneeiansl">
            Fondamenta, movimento, meccanismi, veicoli, strutture e
            progettazione originale. Ogni volume aggiunge un livello invece di
            ripetere il precedente.
          </p>
        </Reveal>

        <ol className="mt-9 grid gap-5 sm:mt-12 sm:gap-6 lg:grid-cols-2" data-id="element-268" data-mp="3o8oqtw18rcrl">
          {volumes.map((volume, index) => <Reveal key={volume.number} delay={index * 0.04} data-id="element-269" data-mp="3jawpycimcgb9" data-mpi={index}>
              <li className="flex h-full items-start gap-4 rounded-[1.5rem] bg-white p-4 shadow-card sm:gap-6 sm:rounded-[1.75rem] sm:p-6" data-id="element-270" data-mp="218c3bteqip4">
                <img src={volume.cover} alt={`Copertina del ${volume.number}: ${volume.title}`} className="aspect-[3/4] w-[104px] shrink-0 rounded-xl object-cover shadow-edge ring-1 ring-ink/10 sm:w-[140px] sm:rounded-2xl" loading="lazy" width={900} height={1200} data-id="element-271" data-mp="3t5yh1dwgfsgh" />
                <div className="flex min-w-0 flex-col" data-id="element-272" data-mp="fsv8rcr9ht8f">
                  <p className="text-[11px] font-black uppercase tracking-[0.16em] text-orange sm:text-xs" data-id="element-273" data-mp="trmmuz64jewk">
                    {volume.number}
                  </p>
                  <h3 className="mt-1.5 text-[17px] font-black leading-tight text-ink sm:mt-2 sm:text-2xl" data-id="element-274" data-mp="popzyw9jwwmt">
                    {volume.title}
                  </h3>
                  <p className="mt-2.5 text-[14px] font-semibold leading-snug text-ink/60 sm:mt-3 sm:text-base sm:leading-relaxed" data-id="element-275" data-mp="11tc2nav2dfci">
                    {volume.description}
                  </p>
                </div>
              </li>
            </Reveal>)}
        </ol>

        <div className="mt-7 flex flex-col items-center gap-4 rounded-2xl bg-ink px-5 py-6 text-center sm:mt-9 sm:flex-row sm:justify-between sm:px-8 sm:py-7 sm:text-left" data-id="element-276" data-mp="1fkqpxtw082pd">
          <div data-id="element-277" data-mp="1piesv73rkgim">
            <p className="text-[15px] font-black leading-snug text-cream sm:text-lg" data-id="element-278" data-mp="1phvc3tpuny66">
              Tutti i sei volumi sono inclusi in un unico download.
            </p>
            <p className="mt-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-cream/50" data-id="element-279" data-mp="1uf5ahyv7vk65">
              <span className="line-through" data-id="element-280" data-mp="3rc4ek5zr6sq5">{FULL_PRICE}</span> · oggi{' '}
              <span className="text-sun" data-id="element-281" data-mp="3qitcinbanr">{PRICE}</span>
            </p>
          </div>
          <CtaButton size="md" className="w-full sm:w-auto" data-id="element-282" data-mp="2dejjo0frag1t">
            Voglio la collezione
          </CtaButton>
        </div>
      </div>
    </section>;
}